<section class="detail-card metrics-card">
  <h4>Metrics (Calculated)</h4>
  <button
    *ngIf="!readOnly"
    type="button"
    class="recalculate-button"
    [disabled]="recalculating"
    [attr.aria-label]="
      recalculating ? 'Recalculating score' : 'Recalculate score'
    "
    [title]="recalculating ? 'Recalculating score' : 'Recalculate score'"
    (click)="onRecalculateScore()"
  >
    <mat-icon>refresh</mat-icon>
  </button>
  <div class="detail-field">
    <label>Score</label>
    <span>{{ collector.score }}</span>
  </div>
  <div class="detail-field">
    <label>Rejection Rate</label>
    <span>{{ collector.rejectionRate }}%</span>
  </div>
</section>
